import gql from 'graphql-tag';

export default gql`
  mutation adminDeleteSite($siteId: ID!) {
    adminDeleteSite(siteId: $siteId)
  }
`;
